import api from '@pray/shared/utils/api';

import type { GetExperimentFunnelAnalyticsResponse } from './types/api';

export type GetExperimentFunnelAnalyticsParams = {
  experimentId: string;
  instanceName?: string;
  startDate?: string;
  endDate?: string;
};

/**
 * Fetches funnel analytics data for an experiment.
 * Returns conversion data for Registration -> Trial -> Subscription funnel,
 * comparing Control vs Treatment variations.
 *
 * @param params - The parameters for the request
 * @param params.experimentId - The ID of the experiment
 * @param params.instanceName - Optional instance name for faster lookup
 * @param params.startDate - Optional start date (YYYY-MM-DD), defaults to 90 days ago
 * @param params.endDate - Optional end date (YYYY-MM-DD), defaults to yesterday
 * @returns The funnel analytics data with variations comparison
 */
export async function getExperimentFunnelAnalytics({
  experimentId,
  instanceName,
  startDate,
  endDate,
}: GetExperimentFunnelAnalyticsParams) {
  if (!experimentId) throw new Error('Experiment ID is required');

  const url = `/web/studio/experiments/${experimentId}/analytics/funnel`;
  const params: Record<string, string> = {};

  if (instanceName) {
    params.instance_name = instanceName;
  }

  if (startDate) {
    params.start_date = startDate;
  }

  if (endDate) {
    params.end_date = endDate;
  }

  const response = await api.executeGetRequest<GetExperimentFunnelAnalyticsResponse>(url, params);

  return response.data.data;
}
